import type {DetailedHTMLProps, ImgHTMLAttributes} from "react";
import React, {useMemo} from 'react';
import MissMinutesTimelyPng from '../MissMinutesTimely.png';
import YearPlusPng from '../YearPlus.png';

type Props =  DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
    currentTimelyStreak : number;
    height : number;
}

type StreakSettings = {
    streakPath : undefined | string
    backgroundColor : string;
    piColor : string;
}

const currentTimelyStreakToSettings = (currentTimelyStreak : number) : StreakSettings => {
    let streakPath : undefined | string = undefined;
    let backgroundColor  = '#FFFFFF';
    let piColor  = '#f06800';
    const streakWeek = currentTimelyStreak % 12;
    switch (streakWeek) {
        case 1:
            streakPath = 'M 114 111 L 114 15 A 100 100 0 0 1 161 28 L 114 111 Z';
            break;
        case 2:
            streakPath = 'M 114 111 L 114 15 A 100 100 0 0 1 195 64 L 114 111 Z';
            break;
        case 3:
            streakPath = 'M 114 111 L 114 15 A 100 100 0 0 1 211 112 L 114 111 Z';
            break;
        case 4:
            streakPath = 'M 114 111 L 114 15 A 100 100 0 0 1 198 159 L 114 111 Z';
            break;
        case 5:
            streakPath = 'M 114 111 L 114 15 A 94 94 0 0 1 162 192 L 114 111 Z';
            break;
        case 6:
            streakPath = 'M 114,19 A 95,93 0 1 1 113,204 L 114,112 Z';
            break;
        case 7:
            streakPath = 'M 114,19 A 95,93 0 1 1 68,191 L 114,112 Z';
            break;
        case 8:
            streakPath = 'M 114,19 A 95,93 0 1 1 37,158 L 114,112 Z';
            break;
        case 9:
            streakPath = 'M 114,19 A 95,93 0 1 1 20,112 L 114,112 Z';
            break;
        case 10:
            streakPath = 'M 114,19 A 95,93 0 1 1 32,65 L 114,112 Z';
            break;
        case 11:
            streakPath = 'M 114,19 A 95,93 0 1 1 67,30 L 114,112 Z';
            break;
    }

    switch (Math.floor((currentTimelyStreak -1) / 12)) {
        case -1:
        case 0:
            backgroundColor = '#FFFFFF';
            piColor = '#f6a466';
            break;
        case 1:
            if (streakWeek === 0) {
                backgroundColor = '#c2c2c2';
                piColor = '#c2c2c2';
            } else {
                backgroundColor = '#f6a466';
                piColor = '#c2c2c2';
            }
            break;
        case 2:
            backgroundColor = '#c2c2c2';
            piColor = '#bbbb00';
            break;
        case 3:
            backgroundColor = '#bbbb00';
            piColor = '#9c2a22';
            break;
        case 4:
            backgroundColor = '#9c2a22';
            piColor = 'url(#rainbowGradient)';
            break;
        default:
            backgroundColor = 'url(#rainbowGradient)';
            piColor = 'url(#rainbowGradient)';
            streakPath = undefined;
    }

    return {
        streakPath,
        backgroundColor,
        piColor,
    };
}

const MissMinutesTimely : React.FC<Props> = (props : Props) => {
    const {streakPath, piColor, backgroundColor} = useMemo(
        () => currentTimelyStreakToSettings(props.currentTimelyStreak),
        [props.currentTimelyStreak]
    );


    if (props.currentTimelyStreak >= 61) {
        return <span
            title={`${props.currentTimelyStreak} weeks in a row`}
            style={{display: 'inline-block'}}
        >
            <img
                className={props.className}
                src={YearPlusPng}
                alt={`${props.currentTimelyStreak} weeks in a row`}
                style={{height: props.height}}
            />
        </span>;
    }
    return <span
        title={`${props.currentTimelyStreak} weeks in a row`}
        style={{display: 'inline-block'}}
    >
        <svg
            className={props.className}
            style={{height: props.height}}
            xmlns="http://www.w3.org/2000/svg"
            id="svg58"
            viewBox="0 0 235 265"
            fillRule="evenodd"
            clipRule="evenodd"
            imageRendering="optimizeQuality"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
            version="1.1"
        >
            <defs id="defs58">
                <linearGradient id="rainbowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="red"/>
                    <stop offset="16.6%" stopColor="orange"/>
                    <stop offset="33.3%" stopColor="yellow"/>
                    <stop offset="50%" stopColor="green"/>
                    <stop offset="66.6%" stopColor="blue"/>
                    <stop offset="83.3%" stopColor="indigo"/>
                    <stop offset="100%" stopColor="violet"/>
                </linearGradient>
            </defs>
            <circle cx="115" cy="112" r="94" fill={backgroundColor}/>
            {streakPath
                ? <path d={streakPath} fill={piColor} stroke="none" opacity="1" strokeWidth="0"/>
                : <circle cx="115" cy="112" r="94" fill={piColor} opacity="1"/>
            }
            <image href={MissMinutesTimelyPng} width="235" height="265"/>
        </svg>
    </span>
}

export default MissMinutesTimely;
